import { render, staticRenderFns } from "./EditProfileGeneralDetails.vue?vue&type=template&id=1173fe48&scoped=true"
import script from "./EditProfileGeneralDetails.vue?vue&type=script&lang=js"
export * from "./EditProfileGeneralDetails.vue?vue&type=script&lang=js"
import style0 from "./EditProfileGeneralDetails.vue?vue&type=style&index=0&id=1173fe48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1173fe48",
  null
  
)

export default component.exports